// extracted by mini-css-extract-plugin
export default {"container_warning":"certificateLetterList_container_warning__WWHrm"};